export { TestResultDetailsPage } from "./details";
export { TestResultPdfPage } from "./pdf";
export { default } from "./resultPage";
export { DetailRecordPage } from "./detailRecord";
export { TestInformationPage } from "./testInformation";
export { UnderstandingYourResultsPage } from "./understandingYourResults";
export { ShareFetalSexPage } from "./shareFetalSex";
export { DownloadableResultsGuidePage } from "./downloadableResultsGuide";
